import { BirthDay } from './Types';

/**
 * Convert Formik compliant object to simple date string.
 * Also make sure that potentially faulty empty values for month or day are converted to "01".
 */
export const convertBirthDayToString = (birthDay: BirthDay): string =>
    `${birthDay.year}-${birthDay.month || '01'}-${birthDay.day || '01'}`;

export const convertStringToBirthDay = (birthDayString: string): BirthDay => {
    const splitBirthDate = birthDayString.split('-');
    return { year: splitBirthDate[0], month: splitBirthDate[1], day: splitBirthDate[2] };
};

export function objectToQueryString(obj: object): string {
    const queryStringParts = [];
    for (const [key, value] of Object.entries(obj)) {
        if (Array.isArray(value)) {
            for (const item of value) {
                queryStringParts.push(key + '[]=' + encodeURIComponent(item));
            }
        } else {
            queryStringParts.push(key + '=' + encodeURIComponent(value));
        }
    }
    return queryStringParts.join('&');
}

type EqualsTrue<T> = T extends undefined ? never : T extends null ? never : T extends '' ? never : T;

export const genericJsonFetch = (
    input: RequestInfo,
    onSuccess: (data: EqualsTrue<any>) => void,
    errorMessage: string,
    failureMessage: string,
    init?: RequestInit,
    onError?: (json: any) => void,
    onFailure?: (error: Error) => void,
) => {
    fetch(input, init)
        .then((response) => response.json())
        .then((json: any) => {
            if (json.errors || !json.data) {
                console.error(errorMessage);

                if (onError && typeof onError === 'function') {
                    onError(json);
                }
            } else {
                onSuccess(json.data);
            }
        })
        .catch((error: Error) => {
            console.error(errorMessage, error);
            if (onFailure && typeof onFailure === 'function') {
                onFailure(error);
            }
        });
};

export const genericJsonFetchWithoutResponseData = (
    input: RequestInfo,
    onSuccess: () => void,
    errorMessage: string,
    failureMessage: string,
    init?: RequestInit,
    onError?: (json: any) => void,
    onFailure?: (error: Error) => void,
) => {
    genericJsonFetch(
        input,
        (data) => {
            if (data.success) {
                onSuccess();
            }
        },
        errorMessage,
        failureMessage,
        init,
        onError,
        onFailure,
    );
};

export type UriComponentEncodable = string | number | boolean;

export type AddableToParams =
    | UriComponentEncodable
    | AddableToParams[]
    | { [property: string]: AddableToParams }
    | undefined;

export const addToParams = (params: URLSearchParams, path: string, value: AddableToParams): void => {
    if (value === undefined) {
        return;
    }

    if (Array.isArray(value)) {
        for (const item of value) {
            addToParams(params, `${path}[]`, item);
        }
        return;
    }

    if (typeof value === 'object') {
        for (const [propertyName, propertyValue] of Object.entries(value)) {
            addToParams(params, `${path}[${propertyName}]`, propertyValue);
        }
        return;
    }

    params.append(path, encodeURIComponent(value));
};

// https://stackoverflow.com/a/822486
export const stripTags = (textWithMarkup: string) => {
    const div = document.createElement('div');
    div.innerHTML = textWithMarkup.replace(/<br\s*\/?>/gi, '&nbsp;');

    return div.textContent || div.innerText || '';
};
